import {
  DiagnosticsStackGenericResponse,
  RemoteDiagnosticsSuccessResponseData,
  RemoteDiagnosticsVddRootMetadataResponse,
  RemoteDiagnosticsVddRootStructureResponse,
} from '../remote-diagnostics.model';
import { MockedVdd } from './MockedVdd.model';
import { VddNames } from '../../../../../app/+installations/diagnostics-overlay/tabs-content/extended-parameters/diagnostics-constants';

export class ViessmannIdentificationNumber implements MockedVdd {
  readSingleSync(logicalLink?: string): RemoteDiagnosticsSuccessResponseData {
    return {
      RES: ' 62 01 79 37 37 32 32 37 38 30 32 38 30 32 32 30 32 32 30',
      request_parameter_name: 'PA_DataIdent',
      service: 'DS_ReadDataByIdent',
      ecu: 'LL_0002_HMU_CAN01',
      requestDate: new Date().toISOString(),
      ecuvariant: logicalLink,
      request_parameter_value: VddNames.ViessmannIdentificationNumber,
      securitystatus: '',
      type: 'ReadVddDataByVdd',
      structure: [
        {
          semantic: 'SERVICE-ID',
          path: 'PA_ServiID',
          unit: '',
          translationid: '',
          dopname: '',
          name: 'PA_ServiID',
          value: '98',
        },
        {
          semantic: '',
          path: 'PA_DataIdent',
          unit: '',
          translationid: '',
          dopname: '2 Byte Text Table VDD-Greenbook',
          name: 'PA_DataIdent',
          value: 'ViessmannIdentificationNumber',
        },
        {
          semantic: '',
          path: 'PA_DataRecor',
          translationid: '',
          dopname: '2 Byte Table VDD Greenbook',
          name: 'PA_DataRecor',
          structure: [
            {
              semantic: 'ITEMID',
              path: 'PA_DataRecor/PA_ItemId',
              unit: '',
              translationid: 'TI_ItemId',
              dopname: '7 Byte Identical ItemId',
              name: 'PA_ItemId',
              value: '7722780',
            },
            {
              semantic: 'PRODUCTIONYEAR',
              path: 'PA_DataRecor/PA_Year',
              unit: '',
              translationid: 'TI_Year',
              dopname: '1 Byte Identical uint8 ASCII',
              name: 'PA_Year',
              value: '2',
            },
            {
              semantic: 'COUNTER',
              path: 'PA_DataRecor/PA_ProceCount',
              unit: '',
              translationid: 'TI_ProcessCounter',
              dopname: '5 Byte Identical ProcessCounter',
              name: 'PA_ProceCount',
              value: '80220',
            },
            {
              semantic: 'COUNTER',
              path: 'PA_DataRecor/PA_OverfCountOne',
              unit: '',
              translationid: 'TI_OverflowCounterOne',
              dopname: '1 Byte Identical uint8 ASCII',
              name: 'PA_OverfCountOne',
              value: '2',
            },
            {
              semantic: 'COUNTER',
              path: 'PA_DataRecor/PA_OverfTwo',
              unit: '',
              translationid: 'TI_OverflowTwo',
              dopname: '1 Byte Identical uint8 ASCII',
              name: 'PA_OverfTwo',
              value: '2',
            },
            {
              semantic: 'VALUE',
              path: 'PA_DataRecor/PA_Check',
              unit: '',
              translationid: 'TI_Checksum',
              dopname: '1 Byte Identical uint8 ASCII',
              name: 'PA_Check',
              value: '0',
            },
          ],
        },
        {
          semantic: '',
          path: 'PA_RecorDataIdentCheck',
          unit: '',
          translationid: '',
          dopname: '',
          name: 'PA_RecorDataIdentCheck',
          value: '',
        },
      ],
      REQ: ' 22 01 79',
    };
  }
  metadata(): RemoteDiagnosticsVddRootMetadataResponse {
    return {
      request_parameter_name: 'PA_Param',
      service: 'DS_VDDMetaData',
      ecu: 'LL_0002_HMU_CAN01',
      request_parameter_value: VddNames.ViessmannIdentificationNumber,
      type: 'MetaDataByVddAndBaseVariant',
      structure: [
        {
          semantic: '',
          longname: 'Param',
          byteposition: '0',
          dopname: '2 Byte Text Table VDD-Greenbook',
          precision: '',
          byteLength: '16',
          type: 'eKEY',
          shortname: 'PA_Param',
          constraints: '',
          path: 'PA_Param',
          unit: '',
          translationid: '',
          bitposition: '0',
          name: 'PA_Param',
          interval: '377',
          value: 'ViessmannIdentificationNumber',
        },
        {
          semantic: '',
          longname: 'Value',
          byteposition: '2',
          dopname: '2 Byte Table VDD MetaData',
          precision: '',
          byteLength: '-1',
          type: 'eTABLE',
          shortname: 'PA_Value',
          constraints: '',
          structure: [
            {
              semantic: 'MODIFIABLE',
              longname: 'Modifiable',
              byteposition: '0',
              dopname: '1 Byte TextTable FalseTrue',
              precision: '',
              byteLength: '8',
              type: 'eTEXTTABLE',
              shortname: 'PA_Modif',
              constraints: '',
              structure: [
                { TI_texttableentry: 'TI_False', interval: '0', texttableentry: 'False' },
                { TI_texttableentry: 'TI_True', interval: '1', texttableentry: 'True' },
              ],
              path: 'PA_Value/PA_Modif',
              unit: '',
              translationid: 'TI_Modifiable',
              bitposition: '0',
              name: 'PA_Modif',
              value: 'True',
            },
          ],
          path: 'PA_Value',
          unit: '',
          translationid: '',
          bitposition: '0',
          name: 'PA_Value',
          value: '',
        },
      ],
    };
  }
  structure(): DiagnosticsStackGenericResponse<RemoteDiagnosticsVddRootStructureResponse[]> {
    return {
      type: 'VddStructureByVddAndBaseVariant',
      structure: [
        {
          request_parameter_name: 'PA_Param',
          service: 'DS_VDDPAStruc',
          ecu: 'LL_0002_HMU_CAN01',
          request_parameter_value: VddNames.ViessmannIdentificationNumber,
          type: 'RequestStructureByParameterNameAndValue',
          structure: [
            {
              semantic: '',
              longname: 'Param',
              byteposition: '0',
              dopname: '2 Byte Text Table VDD-Greenbook',
              precision: '',
              byteLength: '16',
              type: 'eKEY',
              shortname: 'PA_Param',
              constraints: '',
              path: 'PA_Param',
              unit: '',
              translationid: '',
              bitposition: '0',
              name: 'PA_Param',
              interval: '377',
              value: 'ViessmannIdentificationNumber',
            },
            {
              semantic: '',
              longname: 'Structure',
              byteposition: '2',
              dopname: '2 Byte Table VDD Greenbook',
              precision: '',
              byteLength: '-1',
              type: 'eTABLE',
              shortname: 'PA_Struc',
              constraints: '',
              structure: [
                {
                  semantic: 'ITEMID',
                  longname: 'ItemId',
                  byteposition: '0',
                  dopname: '7 Byte Identical ItemId',
                  precision: '',
                  byteLength: '56',
                  type: 'eA_UNICODE2STRING',
                  shortname: 'PA_ItemId',
                  constraints: '[7:7]',
                  path: 'PA_Struc/PA_ItemId',
                  unit: '',
                  translationid: 'TI_ItemId',
                  bitposition: '0',
                  name: 'PA_ItemId',
                  value: '',
                },
                {
                  semantic: 'PRODUCTIONYEAR',
                  longname: 'Year',
                  byteposition: '7',
                  dopname: '1 Byte Identical uint8 ASCII',
                  precision: '',
                  byteLength: '8',
                  type: 'eA_UNICODE2STRING',
                  shortname: 'PA_Year',
                  constraints: '[1:1]',
                  path: 'PA_Struc/PA_Year',
                  unit: '',
                  translationid: 'TI_Year',
                  bitposition: '0',
                  name: 'PA_Year',
                  value: '',
                },
                {
                  semantic: 'COUNTER',
                  longname: 'ProcessCounter',
                  byteposition: '8',
                  dopname: '5 Byte Identical ProcessCounter',
                  precision: '',
                  byteLength: '40',
                  type: 'eA_UNICODE2STRING',
                  shortname: 'PA_ProceCount',
                  constraints: '[5:5]',
                  path: 'PA_Struc/PA_ProceCount',
                  unit: '',
                  translationid: 'TI_ProcessCounter',
                  bitposition: '0',
                  name: 'PA_ProceCount',
                  value: '',
                },
                {
                  semantic: 'COUNTER',
                  longname: 'OverflowCounterOne',
                  byteposition: '13',
                  dopname: '1 Byte Identical uint8 ASCII',
                  precision: '',
                  byteLength: '8',
                  type: 'eA_UNICODE2STRING',
                  shortname: 'PA_OverfCountOne',
                  constraints: '[1:1]',
                  path: 'PA_Struc/PA_OverfCountOne',
                  unit: '',
                  translationid: 'TI_OverflowCounterOne',
                  bitposition: '0',
                  name: 'PA_OverfCountOne',
                  value: '',
                },
                {
                  semantic: 'COUNTER',
                  longname: 'OverflowTwo',
                  byteposition: '14',
                  dopname: '1 Byte Identical uint8 ASCII',
                  precision: '',
                  byteLength: '8',
                  type: 'eA_UNICODE2STRING',
                  shortname: 'PA_OverfTwo',
                  constraints: '[1:1]',
                  path: 'PA_Struc/PA_OverfTwo',
                  unit: '',
                  translationid: 'TI_OverflowTwo',
                  bitposition: '0',
                  name: 'PA_OverfTwo',
                  value: '',
                },
                {
                  semantic: 'VALUE',
                  longname: 'Checksum',
                  byteposition: '15',
                  dopname: '1 Byte Identical uint8 ASCII',
                  precision: '',
                  byteLength: '8',
                  type: 'eA_UNICODE2STRING',
                  shortname: 'PA_Check',
                  constraints: '[1:1]',
                  path: 'PA_Struc/PA_Check',
                  unit: '',
                  translationid: 'TI_Checksum',
                  bitposition: '0',
                  name: 'PA_Check',
                  value: '',
                },
              ],
              path: 'PA_Struc',
              unit: '',
              translationid: '',
              bitposition: '0',
              name: 'PA_Struc',
              value: '',
            },
          ],
        },
      ],
    };
  }
}
